export const config = {
  title: 'J&A Remodeling LLC | Premier Home Remodeling in Wichita, KS',
  meta: {
    description:
      'J&A Remodeling LLC offers top-quality home remodeling services in Wichita, KS. From kitchen and bathroom renovations to full home makeovers, we bring your vision to life with expert craftsmanship.',
    keywords: [
      'J&A Remodeling LLC',
      'Home Remodeling Wichita KS',
      'Kitchen Renovation',
      'Bathroom Remodeling',
      'Home Improvement Wichita',
      'Remodeling Contractors Kansas',
    ],
    author: 'J&A Remodeling LLC',
    canonicalUrl: 'https://jaremodelingllc.com/',
  },
  sections: {
    header: {
      businessName: 'J&A Remodeling LLC',
    },
    sectionB: {
      heroTitle: 'J&A Remodeling LLC',
      heroSubtitle: 'Transforming Homes with Quality and Care in Wichita, KS',
      learnAboutText: 'Discover Our Services',
      phoneNumber: '3165700924',
      phoneLabel: '(316) 570-0924',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/1408152924/photo/close-up-on-a-repairman-fixing-an-electrical-outlet.jpg?s=612x612&w=0&k=20&c=UJC0TPgHVg9r9ZNUhejVPtJt8tZ17-ZeKSns86_tSGI=',
      cardData: [
        {
          title: 'Kitchen Remodeling',
          description:
            'Revamp your kitchen with modern designs and high-quality finishes tailored to your needs.',
        },
        {
          title: 'Bathroom Renovations',
          description:
            'Transform your bathroom into a luxurious and functional space with our expert remodeling services.',
        },
        {
          title: 'Whole Home Makeovers',
          description:
            'Comprehensive remodeling solutions to give your entire home a fresh, new look.',
        },
      ],
      description:
        'At J&A Remodeling LLC, we specialize in bringing your home remodeling dreams to reality. Our team is dedicated to delivering exceptional craftsmanship and personalized service to homeowners in Wichita, KS.',
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'Explore our range of home remodeling services designed to enhance the beauty and functionality of your living spaces.',
      cards: [
        {
          title: 'Kitchen Remodeling',
          description:
            'Custom kitchen designs that combine aesthetics and functionality to create your ideal cooking space.',
          imageSrc: 'https://media.istockphoto.com/id/1157761081/photo/installing-new-in-modern-kitchen-of-installation-base-for-island-in-center.jpg?s=612x612&w=0&k=20&c=I4qIhF8gbiUMQxpVw6sGeux8-PvRilofcBCanCnMdw8=',
          imageAlt: 'Kitchen Remodeling',
        },
        {
          title: 'Bathroom Remodeling',
          description:
            'Elegant and practical bathroom renovations tailored to your preferences.',
          imageSrc: 'https://media.istockphoto.com/id/1345670554/photo/latin-american-plumber-fixing-a-toilet-in-the-bathroom.jpg?s=612x612&w=0&k=20&c=YPOBAW4scHqOcY2e-kW6AHDvc1ypEAtgJ8Do1DiuJXA=',
          imageAlt: 'Bathroom Remodeling',
        },
        {
          title: 'Living Space Upgrades',
          description:
            'Enhance your living areas with our expert remodeling services, creating comfortable and stylish spaces.',
          imageSrc: 'https://media.istockphoto.com/id/1783705805/photo/mature-deli-owner-taking-inventory-on-store-shelves-using-a-clipboard.jpg?s=612x612&w=0&k=20&c=KMtJnE4uOptIdTohk1W1JmLvesge4cm5MeUvUVCY5K8=',
          imageAlt: 'Living Space Upgrades',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Basement Finishing',
        'Room Additions',
        'Exterior Renovations',
        'Flooring Installation',
        'Custom Cabinetry',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://bc-user-uploads.brandcrowd.com/public/media-Production/0b805ba9-75c4-4f21-ae36-1b8598342238/14aee39e-930c-40cd-ab10-7cddbf270cf8_2x',
        alt: 'J&A Remodeling LLC Team',
      },
      aboutText: [
        'J&A Remodeling LLC is a trusted home remodeling company based in Wichita, KS. We are committed to delivering high-quality renovation services that meet the unique needs of each client.',
        'Our team of skilled professionals works closely with homeowners to ensure every project is completed with precision and care, resulting in spaces that are both beautiful and functional.',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'J&A Remodeling LLC Logo',
      businessName: 'J&A Remodeling LLC',
      contact: {
        phone: '3165700924',
        phoneLabel: '(316) 570-0924',
        email: 'javitia007@gmail.com',
        website: 'https://jaremodelingllc.com/',
        address: '11000 E Longlake St, Wichita, KS 67207, USA',
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedIn: null,
        youtube: null,
      },
    },
    sectionF: {
      address: '11000 E Longlake St, Wichita, KS 67207, USA',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3308.1234567890123!2d-97.1234567890123!3d37.1234567890123!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87a1234567890123%3A0x1234567890123456!2s11000%20E%20Longlake%20St%2C%20Wichita%2C%20KS%2067207%2C%20USA!5e0!3m2!1sen!2sus!4v1712608000000!5m2!1sen!2sus',
    },
  },
};

export default config;
